import React, { Component, useEffect,useState } from 'react'
import RequestHandler from "util/RequestHandler";
import moment from "moment";
import { ColumnHelper } from "util/TableHelper";
import "../../Akode/style.css";
import { Table, Empty, Col, Row, Tooltip, message } from "antd";



const AccountBalanceTable = (props) => {
    const [tableData, setTableData] = useState({
        data: [],
        total: 0,
        loading: true,
      });
      const [tableDataQueryOptions, setTableDataQueryOptions] = useState({
        skip: 0,
        take: 5,
        current: 1,
        filter: "",
      });
    
      useEffect(() => getTableData(), [tableDataQueryOptions]);
    
      const getFilterQuery = () => {
        const { filter } = tableDataQueryOptions;
    
        const conditions = [];
        let query = "";
    
        if (filter) {
          conditions.push(filter);
        }
    
        if (conditions.length !== 0) {
          query = "$filter=" + conditions.join(" and ");
        }
        return query;
      };
    
      const getTableData = () => {
        setTableData({
          ...tableData,
          loading: true,
        });
    
        const { skip, take } = tableDataQueryOptions;
    
         RequestHandler.get(
           `/ToslaAccountBalance?$count=true&${getFilterQuery()}&$skip=${skip}&$top=${take}`
         ).then((response) => {
           setTableData({
             data: response.value,
             total: response["@odata.count"],
             loading: false,
           });
         });
      };
    
      const paging = (p) => {
        setTableDataQueryOptions((prevState) => {
          return {
            ...prevState,
            skip: (p.current - 1) * prevState.take,
            take: p.pageSize,
            current: p.current,
          };
        });
      };
    
      const tableColumns = [
        {
          title: "Tarih",
          dataIndex: "date",
          align: "center",
          render: (data, row, index) => moment(data).format("DD.MM.YYYY"),
        },
        {
          title: "Tutar",
          dataIndex: "amount",
          align:"center",
          render: (data, row, index) => <p style={{ color:row.debtOrCredit === "A" ?'green' : 'darkred'}}><>{row.debtOrCredit === "B" ? "-" + data.toLocaleString("tr-TR", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }): data.toLocaleString("tr-TR", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}</></p>,
        },
        {
          title: "Yeni Bakiye",
          dataIndex: "newBalance",
          align:"center",
          render: ColumnHelper.renderDecimal,
        },
      ];
        return (
            <>
        <Row id="tableArea">
            <Col span={24}>
            <Table
                columns={tableColumns.filter((column) => !column.isRowDetail)}
                locale={{
                emptyText: (
                    <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description="Veri Yok"
                    />
                ),
                }}
                
                style={{
                overflowX: "auto",
                maxHeight: "100%",
                width: "100%",
                }}
                rowKey="id"
                filterable={true}
                sortable={true}
                onChange={paging}
                pagination={false}
                dataSource={tableData.data}
                loading={tableData.loading}
                size="small"
            />
            </Col>
        </Row>
            </>
        )
}
export default AccountBalanceTable